import { useEffect, useState, useCallback } from 'react';
import { downloadFile, httpGet } from '../../../../components/utils';
import { IncidentFilters } from '../types/Incidents';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { AxiosResponse } from 'axios';

type ReportDto = {
    responseId: string;
};

export const useGetIncidentReport = (filters: IncidentFilters) => {
    const [data, setData] = useState<ReportDto>();
    const [loading, setLoading] = useState(false);

    const downloadReport = useCallback(async () => {
        setLoading(true);
        try {
            const result = (await httpGet('/incidents/generateReport', {
                [HTTP_OPTIONS.REQ_OPTIONS]: { params: filters }
            })) as unknown as AxiosResponse<ReportDto>;
            setData(result.data);
        } finally {
            setLoading(false);
        }
    }, [filters]);

    useEffect(() => {
        if (data?.responseId) {
            downloadFile(`/incidents/downloadReport/${data.responseId}`);
        }
    }, [data?.responseId]);

    return { downloadReport, downloadingReport: loading };
};
